import React from 'react';

import { Box, Text } from 'app/shopify/theme';

import { Tag, type TagProps } from './Tag';

const TREATMENTS = [
  { name: 'Primary', type: 'primary', inverted: false },
  { name: 'Primary Neutral', type: 'primaryNeutral', inverted: false },
  { name: 'Secondary', type: 'secondary', inverted: false },
  { name: 'Primary · inverted', type: 'primary', inverted: true },
  { name: 'Secondary · inverted', type: 'secondary', inverted: true },
] as const;

export function TagShowcase({ leadingIcon }: Pick<TagProps, 'leadingIcon'>) {
  return (
    <Box flexDirection="row" flexWrap="wrap" gap="spacing.general.x4">
      {TREATMENTS.map(({ name, type, inverted }) => (
        <Box key={name} gap="spacing.general.x2">
          <Text variant="bodyXSmall">{name}</Text>
          <Box
            alignItems="flex-start"
            gap="spacing.general.x3"
            padding="spacing.general.x3"
            borderRadius="radius.md"
            backgroundColor={inverted ? 'surface.brand.strong' : 'surface.primary'}
          >
            <Tag label="Tag label" type={type} size="default" inverted={inverted} leadingIcon={leadingIcon} />
            <Tag label="Tag label" type={type} size="small" inverted={inverted} leadingIcon={leadingIcon} />
          </Box>
        </Box>
      ))}
    </Box>
  );
}
